import {
  GetOrdersStatsRequest,
  GetOrdersStatsResponse,
  GetRevenueStatsByMenuCategoryIdRequest,
  GetRevenueStatsByMenuCategoryIdResponse,
  GetRevenueStatsByMenuItemIdRequest,
  GetRevenueStatsByMenuItemIdResponse,
  GetTimeSeriesStatsRequest,
  GetTimeSeriesStatsResponse,
} from "./requestsResponses";
import { StatsApiMethods } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";

export const getStats = async (params: {
  from: Date;
  to: Date;
  menuId: number;
}) => {
  const response = await execute<GetOrdersStatsRequest, GetOrdersStatsResponse>(
    StatsApiMethods.getStats,
    {
      fromDate: params.from,
      toDate: params.to,
      menuId: params.menuId,
    }
  );
  return {
    err: !(
      response.status === 200 &&
      response.data.executionStatus === ExecutionStatus.Finished
    ),
    ...response.data,
  };
};

export const getRevenueStatsByMenuCategoryId = async (
  params: GetRevenueStatsByMenuCategoryIdRequest
) => {
  const response = await execute<
    GetRevenueStatsByMenuCategoryIdRequest,
    GetRevenueStatsByMenuCategoryIdResponse
  >(StatsApiMethods.getRevenueStatsByMenuCategoryId, params);
  return {
    err: !(
      response.status === 200 &&
      response.data.executionStatus === ExecutionStatus.Finished
    ),
    ...response.data,
  };
};

export const getRevenueStatsByMenuItemId = async (
  params: GetRevenueStatsByMenuItemIdRequest
) => {
  const response = await execute<
    GetRevenueStatsByMenuItemIdRequest,
    GetRevenueStatsByMenuItemIdResponse
  >(StatsApiMethods.getRevenueStatsByMenuItemId, params);
  return {
    err: !(
      response.status === 200 &&
      response.data.executionStatus === ExecutionStatus.Finished
    ),
    ...response.data,
  };
};

export const getTimeSeriesStats = async (params: GetTimeSeriesStatsRequest) => {
  const response = await execute<
    GetTimeSeriesStatsRequest,
    GetTimeSeriesStatsResponse
  >(StatsApiMethods.getTimeSeriesStats, params);
  return {
    err: !(
      response.status === 200 &&
      response.data.executionStatus === ExecutionStatus.Finished
    ),
    ...response.data,
  };
};
